/* Winkelmandlade (uit snippets/cart-drawer.liquid; snelheid 20-10: extern en gecachet i.p.v. 41 KB inline op elke pagina).
   Liquid-waarden (routes, USP-tekst) komen uit de JSON-config [data-pf-cart-config]. Verder letterlijk het oude script. */
(function () {
  'use strict';

  /* ─── DOM refs ─── */
  var overlay   = document.getElementById('pf-cart-overlay');
  var drawer    = document.getElementById('pf-cart-drawer');
  if (!drawer || drawer.dataset.pfCartInitialized) return;
  drawer.dataset.pfCartInitialized = 'true';
  window.pfCartReady = true; // header-winkelmandknop opent de lade pas als dit script klaar is (anders gewoon /cart)
  var closeBtn  = document.getElementById('pf-cart-close');
  var continueBtn = document.getElementById('pf-cart-continue');
  var body      = document.getElementById('pf-cart-body');
  var footer    = document.getElementById('pf-cart-footer');
  var countEl   = document.getElementById('pf-cart-count');
  var subtotalEl= document.getElementById('pf-cart-subtotal');
  var toast     = document.getElementById('pf-toast');
  var addedBar  = drawer.querySelector('[data-pf-cart-added]');
  var addedText = drawer.querySelector('[data-pf-cart-added-text]');
  var undoBtn   = drawer.querySelector('[data-pf-cart-undo]');
  var statusEl  = drawer.querySelector('[data-pf-cart-status]');
  var CONFIG = {};
  try { CONFIG = JSON.parse(document.querySelector('[data-pf-cart-config]').textContent); } catch (err) { CONFIG = {}; }
  var LINKS = CONFIG.links || {};
  var toastTimer = null, addedTimer = null;
  var lastFocused = null;
  var lastValidCart = null;
  var cartMutationPending = false;
  /* Locale-aware cart endpoints (routes object). */
  var ROUTES = CONFIG.routes || { cart: '/cart', add: '/cart/add', change: '/cart/change', update: '/cart/update' };
  var addedKeys = [], addedQuantity = 1, bannerShown = false, renderGeneration = 0;

  /* ─── Helpers ─── */
  function formatMoney(cents) {
    var numericCents = Number(cents);
    if (!Number.isFinite(numericCents)) return '€ 0,00';
    return '€ ' + (numericCents / 100).toFixed(2).replace('.', ',');
  }
  function isValidCart(cart) {
    return Boolean(cart && Number.isFinite(Number(cart.item_count)) && Number.isFinite(Number(cart.total_price)) && Array.isArray(cart.items));
  }
  function clearToast() { clearTimeout(toastTimer); toast.classList.remove('is-visible'); toast.textContent = ''; }
  function showToast(msg) {
    toast.style.setProperty('--pf-toast-cart-bottom', ((footer.offsetHeight || 268) + 12) + 'px');
    toast.textContent = msg; toast.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2800);
  }
  function setQuantityControlsDisabled(disabled) {
    body.querySelectorAll('.pf-qty__btn, .pf-cart-item__remove, .pf-cart-item__save, [data-pf-adapter-add], [data-pf-complete-add]').forEach(function (button) {
      // "−" blijft uitgeschakeld bij aantal 1 (verwijderen gaat via de prullenbak).
      button.disabled = disabled || button.dataset.atMin === '1';
    });
    body.setAttribute('aria-busy', disabled ? 'true' : 'false');
  }
  function parseJsonResponse(response) {
    return response.json().catch(function () { return {}; }).then(function (payload) {
      if (!response.ok) { var error = new Error(payload.description || payload.message || 'Cart request failed'); error.status = response.status; throw error; }
      return payload;
    });
  }
  function escapeHtml(str) { return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  var ICON = {
    plus: '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    minus: '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    trash: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l.8 12.2a1.5 1.5 0 0 0 1.5 1.3h6.4a1.5 1.5 0 0 0 1.5-1.3L17.5 7M10 11v6M14 11v6"/></svg>',
    heart: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 20.5S3.5 15.3 3.5 9.2A4.7 4.7 0 0 1 12 6.4a4.7 4.7 0 0 1 8.5 2.8c0 6.1-8.5 11.3-8.5 11.3Z"/></svg>',
    battery: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><rect x="2" y="8" width="17" height="8" rx="1.5"/><path d="M21 11v2M5 11h8v2H5z"/></svg>',
    shield: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21.5s7.5-3.6 7.5-9.4V5.2L12 2.5 4.5 5.2v6.9c0 5.8 7.5 9.4 7.5 9.4Z"/><path d="m8.8 12 2.2 2.2 4.4-4.6"/></svg>',
    check: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>',
    arrow: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>',
    tag: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12V4h8l10 10-8 8L3 12Z"/><circle cx="7.5" cy="7.5" r="1"/></svg>',
    chevron: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>',
    help: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6v.4M12 17h.01"/></svg>',
    qCase: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6.5" y="2.5" width="11" height="19" rx="2.5"/><circle cx="10" cy="6.5" r="1.2"/></svg>',
    qGlass: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6.5" y="2.5" width="11" height="19" rx="2.5"/><path d="m9.5 9 4-4M9.5 13l6-6"/></svg>',
    qCharger: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="8" width="14" height="12" rx="2.5"/><path d="M9 8V4M15 8V4M10 14h4"/></svg>',
    qCable: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 3v4M15 3v4M7 7h10v3a5 5 0 0 1-10 0V7ZM12 15v2a4 4 0 0 0 4 4h2"/></svg>',
    qCond: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 3v18M12 7.5h5M12 12h7M12 16.5h5"/></svg>',
    cart: '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2.2 10.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.1L20.5 8H6.2"/><circle cx="9.5" cy="20" r="1"/><circle cx="17" cy="20" r="1"/></svg>'
  };

  /* ─── Focus management (dialog focus-trap) ─── */
  function getFocusable() {
    var selector = 'a[href], button:not([disabled]), textarea, input, select, summary, [tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice.call(drawer.querySelectorAll(selector)).filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement; });
  }
  function trapFocus(e) {
    if (e.key !== 'Tab' && e.keyCode !== 9) return;
    var focusable = getFocusable();
    if (focusable.length === 0) { e.preventDefault(); try { drawer.focus(); } catch (err) {} return; }
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey) { if (document.activeElement === first || !drawer.contains(document.activeElement)) { e.preventDefault(); try { last.focus(); } catch (err) {} } }
    else if (document.activeElement === last || !drawer.contains(document.activeElement)) { e.preventDefault(); try { first.focus(); } catch (err) {} }
  }

  var previousOverflow = '';
  var background = [];
  function openDrawer(event) {
    var detail = (event && event.detail) || {};
    addedKeys = Array.isArray(detail.added) ? detail.added : [];
    addedQuantity = Math.max(1, parseInt(detail.quantity, 10) || 1);
    bannerShown = false;
    if (drawer.classList.contains('is-open')) { loadCart(); return; }
    lastFocused = detail.opener || document.activeElement;
    if (!lastFocused || lastFocused === document.body) lastFocused = document.querySelector('.pf-header__cart, .pf-header__action[aria-label="Winkelwagen"]');
    previousOverflow = document.body.style.overflow;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    overlay.removeAttribute('aria-hidden');
    var branch = drawer;
    while (branch && branch !== document.body) {
      Array.prototype.forEach.call(branch.parentElement.children, function (sibling) {
        if (sibling === branch || sibling === overlay || sibling === toast) return;
        background.push({ element: sibling, inert: sibling.inert });
        sibling.inert = true;
      });
      branch = branch.parentElement;
    }
    document.body.style.overflow = 'hidden';
    drawer.addEventListener('keydown', trapFocus);
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { if (drawer.classList.contains('is-open')) closeBtn.focus({ preventScroll: true }); }); });
    loadCart();
  }
  function closeDrawer() {
    if (!drawer.classList.contains('is-open')) return;
    clearToast(); hideAdded();
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.inert = true;
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = previousOverflow;
    background.forEach(function (entry) { entry.element.inert = entry.inert; });
    background = [];
    drawer.removeEventListener('keydown', trapFocus);
    if (lastFocused && typeof lastFocused.focus === 'function') { try { lastFocused.focus(); } catch (err) {} }
    lastFocused = null; addedKeys = []; setTitle(false);
  }

  /* ─── Laden ─── */
  function loadCart() {
    body.innerHTML = '<div class="pf-cart-loading"><div class="pf-spinner"></div></div>';
    footer.style.display = 'none';
    fetchCart().then(renderCart).catch(function () {
      // Geen bevestigde mand: geen afrekenknop tot hij weer laadt.
      footer.style.display = 'none'; hideAdded();
      body.innerHTML = '<div class="pf-cart-retry" role="alert"><p>De winkelmand kon niet worden geladen.</p><button type="button" data-pf-cart-retry>Opnieuw proberen</button></div>';
      body.querySelector('[data-pf-cart-retry]').addEventListener('click', loadCart);
    });
  }
  function fetchCart() {
    return fetch(ROUTES.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(parseJsonResponse).then(function (cart) {
      if (!isValidCart(cart)) throw new Error('Invalid cart response');
      return cart;
    });
  }
  function setTitle(added) { if (statusEl) statusEl.textContent = added ? 'Toegevoegd aan je winkelmand' : ''; }
  function showAlert(message) {
    var alert = document.createElement('p');
    alert.className = 'pf-cart-alert'; alert.setAttribute('role', 'alert'); alert.textContent = message;
    body.insertBefore(alert, body.firstChild);
  }
  function itemsLabel(n) { return n === 0 ? 'Nog leeg' : n + (n === 1 ? ' artikel' : ' artikelen'); }

  /* ─── Toegevoegd-balk met Ongedaan maken ─── */
  function hideAdded() { clearTimeout(addedTimer); addedBar.hidden = true; }
  function showAdded(cart) {
    var lines = cart.items.filter(function (item) { return addedKeys.indexOf(item.key) !== -1; });
    if (!lines.length || bannerShown) return;
    bannerShown = true;
    addedText.textContent = lines.length === 1 ? describeItem(lines[0]).title + ' is toegevoegd' : lines.length + ' artikelen zijn toegevoegd';
    addedBar.hidden = false;
    clearTimeout(addedTimer);
    addedTimer = setTimeout(hideAdded, 6000);
  }
  function undoAdded() {
    if (cartMutationPending || !lastValidCart || !addedKeys.length) return;
    var updates = {};
    lastValidCart.items.forEach(function (item) { if (addedKeys.indexOf(item.key) !== -1) updates[item.key] = Math.max(0, item.quantity - addedQuantity); });
    var keys = Object.keys(updates); if (!keys.length) return;
    cartMutationPending = true; undoBtn.disabled = true; setQuantityControlsDisabled(true);
    keys.reduce(function (chain, key) {
      return chain.then(function () { return fetch(ROUTES.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: updates[key] }) }).then(parseJsonResponse); });
    }, Promise.resolve())
      .then(function () { return fetchCart(); })
      .then(function (cart) { addedKeys = []; hideAdded(); cartMutationPending = false; renderCart(cart); if (statusEl) statusEl.textContent = 'Toevoeging ongedaan gemaakt'; closeBtn.focus({ preventScroll: true }); })
      .catch(function () { cartMutationPending = false; return fetchCart().then(function (cart) { renderCart(cart); showAlert('Ongedaan maken lukte niet zeker. Dit is de actuele inhoud van je winkelmand.'); }).catch(function () {}); })
      .finally(function () { cartMutationPending = false; undoBtn.disabled = false; setQuantityControlsDisabled(false); });
  }

  /* ─── Titel en uitvoeringsregels: "iPhone 14" / "128 GB · Wit" / conditie ─── */
  var CONDITIONS = ['Zo goed als nieuw', 'Licht gebruikt'];
  function niceValue(value) { var m = String(value).replace(/\s+/g, '').match(/^(\d{2,4})(gb|tb)$/i); return m ? m[1] + ' ' + m[2].toUpperCase() : String(value); }
  function describeItem(item) {
    var options = Array.isArray(item.options_with_values) ? item.options_with_values.filter(function (o) { return o && o.value && o.value !== 'Default Title'; }) : [];
    var original = String(item.product_title || '');
    var drop = options.map(function (o) { return String(o.value).toLowerCase().replace(/[^a-z0-9]/g, ''); });
    var title = original.split(' ').filter(function (word) { return drop.indexOf(word.toLowerCase().replace(/[^a-z0-9]/g, '')) === -1; }).join(' ').trim() || original;
    var condition = options.filter(function (o) { return CONDITIONS.indexOf(o.value) !== -1; }).map(function (o) { return o.value; });
    var rest = options.filter(function (o) { return CONDITIONS.indexOf(o.value) === -1; }).map(function (o) { return niceValue(o.value); });
    return { title: title, variant: rest.join(' · '), condition: condition[0] || '' };
  }
  // Een refurbished iPhone herken je aan een van de twee toegestane condities als variantoptie.
  function isIPhone(item) { return !!describeItem(item).condition; }

  /* ─── Weergave ─── */
  function renderCart(cart) {
    if (!isValidCart(cart)) return;
    lastValidCart = cart;
    var generation = ++renderGeneration;
    var itemCount = cart.item_count;
    countEl.textContent = itemsLabel(itemCount);
    document.querySelectorAll('[data-pf-cart-count]').forEach(function (el) { el.textContent = itemCount; el.style.display = itemCount > 0 ? '' : 'none'; });
    if (itemCount === 0) { hideAdded(); renderEmpty(); return; }

    subtotalEl.textContent = formatMoney(cart.total_price);
    var discountLine = drawer.querySelector('[data-pf-cart-discountline]');
    var totalDiscount = Number(cart.total_discount) || 0;
    discountLine.hidden = !(totalDiscount > 0);
    if (totalDiscount > 0) drawer.querySelector('[data-pf-cart-discount-amount]').textContent = '− ' + formatMoney(totalDiscount);
    drawer.querySelector('[data-pf-cart-items-label]').textContent = itemsLabel(itemCount);
    footer.style.display = 'flex';

    var adapter = CONFIG.adapter;
    var adapterInCart = adapter && cart.items.some(function (i) { return String(i.product_id) === String(adapter.product) || String(i.variant_id) === String(adapter.variant); });
    var adapterShown = false;
    var lastPhone = -1; cart.items.forEach(function (it, n) { if (describeItem(it).condition) lastPhone = n; }); // 20-10: tip onder de laatste iPhone
    var ul = document.createElement('ul');
    ul.className = 'pf-cart-items';
    cart.items.forEach(function (item, n) {
      var parts = describeItem(item), phone = !!parts.condition;
      var li = document.createElement('li');
      li.className = 'pf-cart-item' + (addedKeys.indexOf(item.key) !== -1 ? ' is-added' : '');
      li.dataset.key = item.key;
      // Harde regel: geen leeg placeholder-beeldvak. Zonder foto → geen beeldtegel.
      var imgHtml = item.image ? '<a class="pf-cart-item__media" href="' + escapeHtml(item.url) + '" tabindex="-1" aria-hidden="true"><img class="pf-cart-item__img" src="' + escapeHtml(item.image) + '" alt="" loading="lazy" width="76" height="76"></a>' : '<span></span>';
      var chips = '';
      if (phone) {
        var blue = parts.condition === 'Licht gebruikt', dots = blue ? 3 : 4, dotHtml = '';
        for (var d = 0; d < 4; d++) dotHtml += '<i' + (d < dots ? ' class="is-on"' : '') + '></i>';
        chips = '<div class="pf-cart-item__chips"><span class="pf-cart-chip pf-cart-chip--cond' + (blue ? ' is-blue' : '') + '"><span class="pf-cart-dots" aria-hidden="true">' + dotHtml + '</span>' + escapeHtml(parts.condition) + '</span><span class="pf-cart-chip">' + ICON.battery + 'Min. 85%</span><span class="pf-cart-chip">' + ICON.shield + '12 mnd garantie</span></div>';
      }
      var unit = item.quantity >= 2 ? '<span class="pf-cart-item__unit">' + item.quantity + ' × ' + formatMoney(item.final_price) + '</span>' : '';
      var canSave = phone && window.PrimeFoneSaved && typeof window.PrimeFoneSaved.toggleWish === 'function';
      var atMin = item.quantity <= 1;
      li.innerHTML = imgHtml +
        '<div class="pf-cart-item__details">' +
          '<div class="pf-cart-item__top"><p class="pf-cart-item__title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(parts.title) + '</a></p><span class="pf-cart-item__price">' + formatMoney(item.final_line_price) + unit + '</span></div>' +
          (parts.variant ? '<p class="pf-cart-item__variant">' + escapeHtml(parts.variant) + '</p>' : '') +
          chips +
          '<div class="pf-cart-item__actions">' +
            '<div class="pf-qty" role="group" aria-label="Aantal ' + escapeHtml(parts.title) + '">' +
              '<button type="button" class="pf-qty__btn pf-qty-dec" aria-label="Minder" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '"' + (atMin ? ' data-at-min="1" disabled' : '') + '>' + ICON.minus + '</button>' +
              '<span class="pf-qty__num" aria-label="Aantal">' + item.quantity + '</span>' +
              '<button type="button" class="pf-qty__btn pf-qty-inc" aria-label="Meer" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">' + ICON.plus + '</button>' +
            '</div>' +
            (canSave ? '<button type="button" class="pf-cart-item__save" data-pf-cart-save="' + escapeHtml(String(item.variant_id)) + '" data-key="' + item.key + '" aria-label="Bewaar ' + escapeHtml(parts.title) + ' in je favorieten">' + ICON.heart + 'Bewaar</button>' : '') +
            '<button type="button" class="pf-cart-item__remove" aria-label="Verwijder ' + escapeHtml(parts.title) + '" data-key="' + item.key + '" data-qty="0">' + ICON.trash + '</button>' +
          '</div>' +
        '</div>';
      // "Geen adapter in de doos": één keer, onder de laatste iPhone (niet tussen twee toestellen), alleen als de lader bestaat en nog niet in de mand zit.
      if (phone && n === lastPhone && adapter && !adapterInCart && !adapterShown) {
        adapterShown = true;
        var note = document.createElement('div');
        note.className = 'pf-cart-adapter';
        note.innerHTML = '<span class="pf-cart-adapter__dot" aria-hidden="true"></span>' + (adapter.image ? '<span class="pf-cart-adapter__img"><img src="' + escapeHtml(adapter.image) + '" alt="" loading="lazy" width="34" height="34"></span>' : '') +
          '<span class="pf-cart-adapter__text"><strong>Geen adapter in de doos</strong><span>' + escapeHtml(adapter.label) + ' · ' + formatMoney(adapter.price) + '</span></span>' +
          '<button type="button" data-pf-adapter-add="' + escapeHtml(String(adapter.variant)) + '" aria-label="Voeg ' + escapeHtml(adapter.title) + ' toe, ' + formatMoney(adapter.price) + '">' + ICON.plus + 'Voeg toe</button>';
        li.appendChild(note);
      }
      ul.appendChild(li);
    });

    body.innerHTML = '';
    body.appendChild(ul);
    var complete = document.createElement('section');
    complete.className = 'pf-cart-complete'; complete.hidden = true; complete.setAttribute('aria-label', 'Maak het compleet');
    body.appendChild(complete);
    body.appendChild(renderDiscount(cart));
    var added = ul.querySelector('.is-added');
    setTitle(!!added);
    if (added) { showAdded(cart); added.scrollIntoView({ block: 'nearest' }); }
    renderComplete(cart, complete, generation);
  }

  function renderEmpty() {
    footer.style.display = 'none';
    setTitle(false);
    var check = ICON.check;
    body.innerHTML =
      '<div class="pf-cart-empty">' +
        '<span class="pf-cart-empty__icon">' + ICON.cart + '</span>' +
        '<p class="pf-cart-empty__text">Je winkelmand is nog leeg</p>' +
        '<p class="pf-cart-empty__sub">Ontdek onze gecontroleerde iPhones of zoek een accessoire voor jouw toestel.</p>' +
        '<div class="pf-cart-empty__tiles">' +
          '<a class="pf-cart-empty__tile" href="' + escapeHtml(LINKS.iphones || '/collections/refurbished-iphones') + '"><strong>Refurbished iPhones</strong><span>Gecontroleerd en simlockvrij</span>' + (CONFIG.images && CONFIG.images.iphones ? '<img src="' + escapeHtml(CONFIG.images.iphones) + '" alt="" loading="lazy" width="160" height="110">' : '') + '<span class="pf-cart-empty__go">' + ICON.arrow + '</span></a>' +
          '<a class="pf-cart-empty__tile" href="' + escapeHtml(LINKS.accessories || '/collections/accessories') + '"><strong>Accessoires</strong><span>Hoesjes, glas en opladen</span>' + (CONFIG.images && CONFIG.images.accessories ? '<img src="' + escapeHtml(CONFIG.images.accessories) + '" alt="" loading="lazy" width="160" height="110">' : '') + '<span class="pf-cart-empty__go">' + ICON.arrow + '</span></a>' +
        '</div>' +
        '<a class="pf-cart-empty__advice" href="' + escapeHtml(LINKS.help || '/pages/contact?view=hulp-bij-kiezen') + '"><span class="pf-cart-empty__advice-ico">' + ICON.help + '</span><span><strong>Twijfel je welke iPhone past?</strong><span>Beantwoord een paar vragen, wij tonen wat past</span></span><span aria-hidden="true">›</span></a>' +
        '<p class="pf-cart-empty__quick-title">Snel naar</p>' +
        '<nav class="pf-cart-empty__quick" aria-label="Snel naar">' +
          '<a href="' + escapeHtml(LINKS.cases) + '">' + ICON.qCase + 'Hoesjes</a><a href="' + escapeHtml(LINKS.glass) + '">' + ICON.qGlass + 'Screenprotectors</a><a href="' + escapeHtml(LINKS.chargers) + '">' + ICON.qCharger + 'Opladers</a><a href="' + escapeHtml(LINKS.cables) + '">' + ICON.qCable + 'Kabels</a><a href="' + escapeHtml(LINKS.conditions) + '">' + ICON.qCond + 'Condities</a>' +
        '</nav>' +
        '<ul class="pf-cart-empty__checks"><li>' + check + escapeHtml(CONFIG.uspCart || '') + '</li></ul>' +
      '</div>';
  }

  /* ─── Kortingscode via de bestaande Cart-API (/cart/update.js) ─── */
  function renderDiscount(cart) {
    var codes = Array.isArray(cart.discount_codes) ? cart.discount_codes.filter(function (c) { return c && c.applicable; }) : [];
    var box = document.createElement('details');
    box.className = 'pf-cart-discount';
    if (codes.length) box.open = true;
    box.innerHTML = '<summary>' + ICON.tag + 'Kortingscode of cadeaukaart' + ICON.chevron + '</summary>' +
      '<form class="pf-cart-discount__form" novalidate><label class="pf-cart-sr" for="pf-cart-code">Kortingscode</label><input id="pf-cart-code" name="code" autocomplete="off" spellcheck="false" placeholder="Kortingscode"><button type="submit">Toepassen</button></form>' +
      (codes.length ? '<div class="pf-cart-discount__codes">' + codes.map(function (c) { return '<span class="pf-cart-discount__code">' + escapeHtml(c.code) + '<button type="button" data-pf-code-remove aria-label="Kortingscode ' + escapeHtml(c.code) + ' verwijderen"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false" style="display:block"><path d="M6 6l12 12M18 6 6 18"/></svg></button></span>'; }).join('') + '</div>' : '') +
      '<p class="pf-cart-discount__msg" role="status" aria-live="polite" data-pf-code-msg></p>' +
      '<p class="pf-cart-discount__note">Een cadeaukaart vul je in bij het afrekenen.</p>';
    box.querySelector('form').addEventListener('submit', function (e) { e.preventDefault(); applyCode(box, box.querySelector('input').value.trim()); });
    box.querySelectorAll('[data-pf-code-remove]').forEach(function (b) { b.addEventListener('click', function () { applyCode(box, ''); }); });
    return box;
  }
  function applyCode(box, code) {
    if (cartMutationPending) return;
    var msg = box.querySelector('[data-pf-code-msg]');
    var removing = code === '';
    cartMutationPending = true;
    fetch(ROUTES.update + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: code }) })
      .then(parseJsonResponse)
      .then(function (cart) {
        var entry = !removing && Array.isArray(cart.discount_codes) ? cart.discount_codes.find(function (c) { return String(c.code).toLowerCase() === code.toLowerCase(); }) : null;
        if (!removing && (!entry || !entry.applicable)) {
          // Niet geldig of niet van toepassing: code weer weghalen, zodat er niets blijft hangen.
          return fetch(ROUTES.update + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: '' }) }).then(parseJsonResponse).then(function () {
            msg.textContent = 'Deze code is niet geldig of niet van toepassing op je winkelmand.'; msg.classList.add('is-error');
          });
        }
        cartMutationPending = false;
        return fetchCart().then(function (fresh) { renderCart(fresh); var b = body.querySelector('.pf-cart-discount'); if (b) { b.open = true; var m = b.querySelector('[data-pf-code-msg]'); m.textContent = removing ? 'Kortingscode verwijderd.' : 'Kortingscode ' + code.toUpperCase() + ' is toegepast.'; } });
      })
      .catch(function () { msg.textContent = 'Toepassen lukte niet. Probeer het opnieuw.'; msg.classList.add('is-error'); })
      .finally(function () { cartMutationPending = false; });
  }

  /* ─── Maak het compleet: alleen bewezen passend, niets dat al in de mand ligt, niets vooraf aangevinkt ─── */
  var productTagCache = {}, feedCache = {}, corePromise = null;
  function loadCore() {
    if (window.PrimeFoneCategory) return Promise.resolve(window.PrimeFoneCategory);
    if (corePromise) return corePromise;
    corePromise = new Promise(function (resolve, reject) {
      if (!CONFIG.core) { reject(new Error('core')); return; }
      var s = document.createElement('script'); s.src = CONFIG.core; s.async = true;
      s.onload = function () { window.PrimeFoneCategory ? resolve(window.PrimeFoneCategory) : reject(new Error('core')); };
      s.onerror = function () { corePromise = null; reject(new Error('core')); };
      document.head.appendChild(s);
    });
    return corePromise;
  }
  function modelOf(item) {
    var url = String(item.url || '').split('?')[0];
    if (!url) return Promise.resolve('');
    if (productTagCache[url] !== undefined) return Promise.resolve(productTagCache[url]);
    return fetch(url + '.js', { headers: { 'Accept': 'application/json' } }).then(parseJsonResponse).then(function (p) {
      var tag = (p.tags || []).map(String).find(function (t) { return t.slice(0, 6) === 'model:'; });
      productTagCache[url] = tag ? tag.slice(6).trim().replace(/ Mini$/, ' mini') : '';
      return productTagCache[url];
    }).catch(function () { return ''; });
  }
  function handleize(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function loadFeed(handle, path) {
    if (feedCache[path]) return feedCache[path];
    var key = 'pf-cart-feed:' + path;
    try { var stored = JSON.parse(sessionStorage.getItem(key) || 'null'); if (stored && Date.now() - stored.t < 10 * 60 * 1000) { feedCache[path] = Promise.resolve(stored.p); return feedCache[path]; } } catch (err) {}
    feedCache[path] = (function () {
      var products = [];
      function page(n) {
        var url = new URL(path, location.origin); url.searchParams.set('view', 'pf-acc-data'); url.searchParams.set('page', n);
        return fetch(url, { credentials: 'same-origin' }).then(function (res) {
          if (res.status === 404) return null;
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        }).then(function (html) {
          if (html === null) return products;
          var node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pf-category-data]');
          if (!node) return products;
          var data = JSON.parse(node.textContent);
          if (data.handle !== handle) return products;
          Array.prototype.push.apply(products, data.products);
          return n < Math.min(data.pages, 8) ? page(n + 1) : products;
        });
      }
      return page(1).then(function (list) { try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), p: list })); } catch (err) {} return list; });
    })();
    feedCache[path].catch(function () { delete feedCache[path]; });
    return feedCache[path];
  }
  function renderComplete(cart, host, generation) {
    var phones = cart.items.filter(isIPhone);
    if (!phones.length || !CONFIG.sources) return;
    var target = phones.find(function (i) { return addedKeys.indexOf(i.key) !== -1; }) || phones[0];
    var inCartProducts = cart.items.map(function (i) { return String(i.product_id); });
    modelOf(target).then(function (model) {
      if (!model || generation !== renderGeneration) return null;
      // Hoesjes per model via de bestaande tagfilter van de collectie (kleine set); validatie blijft in pf-category-core.js.
      var casesPath = CONFIG.sources.cases.replace(/\/$/, '') + '/' + handleize(model + ' Hoesjes');
      return Promise.all([loadCore(), loadFeed('telefoon-hoesjes', casesPath), loadFeed('screenprotectors', CONFIG.sources.glass), loadFeed('kabels', CONFIG.sources.cables)]).then(function (res) {
        if (generation !== renderGeneration) return null;
        var core = res[0];
        var tagsOf = {};
        [res[1], res[2], res[3]].forEach(function (list) { list.forEach(function (p) { tagsOf[String(p.id)] = (p.tags || []).map(function (t) { return String(t).trim().toLowerCase(); }); }); });
        var usable = function (r) { return r.cartVariant && inCartProducts.indexOf(String(r.id)) === -1; };
        var fits = function (r) { return r.model.indexOf(model) !== -1; };
        var cases = core.hydrate('telefoon-hoesjes', res[1]).rows.filter(function (r) { return usable(r) && fits(r); });
        var glass = core.hydrate('screenprotectors', res[2]).rows.filter(function (r) { return usable(r) && fits(r); });
        var port = (CONFIG.connectors || {})[model] || '';
        var conn = port === 'USB-C' ? 'USB-C ↔ USB-C' : port === 'Lightning' ? 'Lightning' : '';
        var cables = conn ? core.hydrate('kabels', res[3]).rows.filter(function (r) {
          var tags = tagsOf[r.id] || [];
          var loose = !tags.some(function (t) { return /car charger/.test(t); });
          var usbc = tags.indexOf('lightning kabel') !== -1 && (tags.indexOf('usb c kabel') !== -1 || tags.indexOf('usb c kabels') !== -1);
          return usable(r) && r.conn.indexOf(conn) !== -1 && loose && (conn !== 'Lightning' || usbc);
        }) : [];
        var picks = [];
        if (cases[0]) picks.push({ row: cases[0], kind: 'Hoesje' });
        if (glass[0]) picks.push({ row: glass[0], kind: 'Screenprotector' });
        else { var gf = glassFallback(); if (gf && inCartProducts.indexOf(String(gf.id)) === -1) { gf.name = 'Screenprotector voor je ' + model; picks.push({ row: gf, kind: 'We sturen de passende versie mee', model: model }); } } // 19-10: algemeen product
        if (cables[0]) picks.push({ row: cables[0], kind: 'Kabel · ' + (conn === 'Lightning' ? 'USB-C naar Lightning' : 'USB-C naar USB-C') });
        return { model: model, picks: picks.slice(0, 3) };
      });
    }).then(function (result) {
      if (!result || generation !== renderGeneration || !result.picks.length) return;
      host.innerHTML = '<div class="pf-cart-complete__head"><h3>Maak het compleet</h3><span>Gekozen voor ' + escapeHtml(result.model) + '</span></div><ul class="pf-cart-complete__list">' +
        result.picks.map(function (p) {
          var r = p.row;
          return '<li class="pf-cart-complete__row">' + (r.image ? '<span class="pf-cart-complete__img"><img src="' + escapeHtml(r.image) + '" alt="" loading="lazy" width="44" height="44"></span>' : '') +
            '<span class="pf-cart-complete__text"><a' + (p.model ? '' : ' href="' + escapeHtml(r.url) + '"') + '>' + escapeHtml(r.name) + '</a><span>' + escapeHtml(p.kind) + '</span></span>' +
            '<span class="pf-cart-complete__price">' + formatMoney(r.price) + '</span>' +
            '<button type="button" class="pf-cart-complete__add" data-pf-complete-add="' + escapeHtml(r.cartVariant) + '"' + (p.model ? ' data-pf-complete-model="' + escapeHtml(p.model) + '"' : '') + ' aria-label="Voeg ' + escapeHtml(r.title) + ' toe, ' + formatMoney(r.price) + '">' + ICON.plus + '</button></li>';
        }).join('') + '</ul>';
      host.hidden = false;
    }).catch(function () { /* geen bewezen aanvulling beschikbaar: blok blijft weg */ });
  }

  /* ─── Toevoegen vanuit de lade (adapter, Maak het compleet) ─── */
  // C1 checkout: "Geschikt voor" alleen bij een bewezen pasvorm (#pf-proven-fit), gelijk aan de productpagina.
  // 19-10: algemeen product "Screenprotector voor jouw iPhone" (snippets/pf-glass-fallback) met "Voor toestel".
  function glassFallback() { try { var n = document.querySelector('[data-pf-glass-fallback]'); return n ? JSON.parse(n.textContent) : null; } catch (err) { return null; } }
  function pfLineItem(variant, voorToestel) {
    if (voorToestel) return { id: Number(variant), quantity: 1, properties: { 'Voor toestel': voorToestel } };
    var fit = '';
    try { var n = document.getElementById('pf-proven-fit'); fit = n ? (JSON.parse(n.textContent)[String(variant)] || '') : ''; } catch (err) { fit = ''; }
    return fit ? { id: Number(variant), quantity: 1, properties: { 'Geschikt voor': fit } } : { id: Number(variant), quantity: 1 };
  }
  function addFromDrawer(button, variant) {
    if (cartMutationPending || !variant) return;
    cartMutationPending = true; setQuantityControlsDisabled(true); button.disabled = true;
    fetch(ROUTES.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [pfLineItem(variant, button.dataset.pfCompleteModel)] }) })
      .then(parseJsonResponse)
      .then(function (data) {
        addedKeys = data && Array.isArray(data.items) ? data.items.map(function (line) { return line.key; }) : [];
        addedQuantity = 1; bannerShown = false;
        return fetchCart().then(function (cart) { cartMutationPending = false; renderCart(cart); });
      })
      .catch(function (error) {
        cartMutationPending = false;
        return fetchCart().then(function (cart) {
          renderCart(cart);
          showAlert(error && error.status === 422 ? 'Dit artikel is niet meer beschikbaar. Er is niets toegevoegd.' : 'Toevoegen lukte niet zeker. Dit is de actuele inhoud van je winkelmand.');
        }).catch(function () { if (lastValidCart) renderCart(lastValidCart); showAlert('Toevoegen lukte niet. Controleer je verbinding en probeer het opnieuw.'); });
      })
      .finally(function () { cartMutationPending = false; setQuantityControlsDisabled(false); });
  }

  /* ─── Bewaar: naar favorieten (pf-saved.js), daarna uit de mand ─── */
  function saveForLater(button) {
    var saved = window.PrimeFoneSaved;
    if (!saved || cartMutationPending) return;
    var id = String(button.dataset.pfCartSave);
    try { var state = saved.state(); if (!state.wish.includes(id)) saved.toggleWish(id); } catch (err) { return; }
    changeQty(button.dataset.key, 0, 'Bewaard in je favorieten');
  }

  /* ─── Aantal wijzigen ─── */
  function changeQty(key, qty, doneMessage) {
    if (cartMutationPending || !key || !Number.isFinite(qty) || qty < 0) return;
    var active = document.activeElement;
    var focusLabel = active && active.dataset && active.dataset.key === key ? active.getAttribute('aria-label') : null;
    cartMutationPending = true;
    setQuantityControlsDisabled(true);
    fetch(ROUTES.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(parseJsonResponse)
      .then(function (cart) {
        if (!isValidCart(cart)) throw new Error('Invalid cart response');
        clearToast();
        if (addedKeys.indexOf(key) !== -1) hideAdded();
        renderCart(cart);
        if (doneMessage && statusEl) statusEl.textContent = doneMessage;
      })
      .catch(function (error) {
        if (error && error.status === 422) {
          // Voorraadweigering: het laatst bevestigde aantal blijft staan.
          if (lastValidCart) renderCart(lastValidCart);
          showAlert('Dit aantal is niet meer beschikbaar. Je winkelmand is niet gewijzigd.');
          return;
        }
        // Onbekende uitkomst (netwerk): eerst de echte mand lezen voordat er opnieuw iets wordt verstuurd.
        return fetchCart().then(function (cart) { renderCart(cart); showAlert('Wijzigen lukte niet zeker. Dit is de actuele inhoud van je winkelmand.'); })
          .catch(function () { if (lastValidCart) renderCart(lastValidCart); showAlert('Wijzigen lukte niet. Controleer je verbinding en probeer het opnieuw.'); });
      })
      .finally(function () {
        cartMutationPending = false;
        setQuantityControlsDisabled(false);
        if (drawer.classList.contains('is-open') && focusLabel) {
          var replacement = Array.prototype.find.call(body.querySelectorAll('button[data-key]'), function (button) { return button.dataset.key === key && button.getAttribute('aria-label') === focusLabel && !button.disabled; });
          (replacement || closeBtn).focus({ preventScroll: true });
        }
      });
  }

  /* ─── Toevoegen via productformulieren (#AddToCartForm) ─── */
  function interceptAddToCartForms() {
    document.querySelectorAll('#AddToCartForm, [data-add-to-cart-form]').forEach(function (form) {
      if (form.dataset.pfIntercepted) return;
      form.dataset.pfIntercepted = '1';
      form.addEventListener('submit', handleAddToCart);
    });
  }
  function handleAddToCart(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : null;
    if (submitBtn) { submitBtn.disabled = true; }
    var formData = new FormData(form);
    var quantity = parseInt(formData.get('quantity'), 10) || 1;
    fetch(ROUTES.add + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Fout bij toevoegen'); });
        return r.json();
      })
      .then(function (data) {
        var added = data && Array.isArray(data.items) ? data.items.map(function (line) { return line.key; }) : (data && data.key ? [data.key] : []);
        document.dispatchEvent(new CustomEvent('cart:open', { detail: { opener: submitBtn, added: added, quantity: quantity } }));
      })
      .catch(function (err) { showToast(err.message || 'Kon product niet toevoegen.'); })
      .finally(function () { if (submitBtn) { submitBtn.disabled = false; if (originalText) submitBtn.textContent = originalText; } });
  }

  /* ─── Klikken in de lade (gedelegeerd) ─── */
  body.addEventListener('click', function (e) {
    var btn = e.target.closest('button');
    if (!btn || btn.disabled) return;
    if (btn.matches('.pf-qty-dec, .pf-qty-inc, .pf-cart-item__remove')) changeQty(btn.dataset.key, parseInt(btn.dataset.qty, 10));
    else if (btn.hasAttribute('data-pf-cart-save')) saveForLater(btn);
    else if (btn.hasAttribute('data-pf-adapter-add')) addFromDrawer(btn, btn.dataset.pfAdapterAdd);
    else if (btn.hasAttribute('data-pf-complete-add')) addFromDrawer(btn, btn.dataset.pfCompleteAdd);
  });

  /* ─── Event listeners ─── */
  document.addEventListener('cart:open', openDrawer);
  overlay.addEventListener('click', closeDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  continueBtn.addEventListener('click', closeDrawer);
  undoBtn.addEventListener('click', undoAdded);
  document.addEventListener('keydown', function (e) { if ((e.key === 'Escape' || e.key === 'Esc') && drawer.classList.contains('is-open')) closeDrawer(); });

  /* Afvangen bij laden + bij later toegevoegde formulieren */
  interceptAddToCartForms();
  var observer = new MutationObserver(function () { interceptAddToCartForms(); });
  observer.observe(document.body, { childList: true, subtree: true });
})();
